module.exports = __webpack_public_path__ + "static/media/m_2.3292e82a.jpg";